import { Div, Label } from "@grassrootly/rn-core";
import { PlayerRatingProps } from "./PlayerRatings.types";
import { getRatingColor } from "./lib";

export function PlayerRating({ rating, size = 14, classNames = [] }: PlayerRatingProps) {
  return (
    <Div
      classNames={[
        `bgColor-{${getRatingColor(rating)}}`,
        "p4",
        "justifyContentCenter",
        "alignItemsCenter",
        `br-{${size * 0.2}}`,
        ...classNames,
      ]}
    >
      <Label classNames={["colorNeutralLighterLight", "l1Bold", `fontSize-{${size}}`]}>
        {rating == 10 ? rating : rating.toFixed(1)}
      </Label>
    </Div>
  );
}
